/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './mobile-header.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '@angular/common';
import * as import4 from '../../../../../app/shared/ui/mobile-header/mobile-header.component';
import * as import5 from '../../../../../app/booking-management/booking-header/booking-header.service';
const styles_MobileHeaderComponent:any[] = [import0.styles];
export const RenderType_MobileHeaderComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_MobileHeaderComponent,
  data: {}
}
);
function View_MobileHeaderComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'icon-back'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.RouterLink,[
      import2.Router,
      import2.ActivatedRoute,
      [
        8,
        (null as any)
      ]
      ,
      import1.Renderer,
      import1.ElementRef
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.backLink;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_MobileHeaderComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'class',
        'header__message'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(3),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-messages'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = ck(v,2,0,'/users/',co.getActiveUserId(),'inbox');
    ck(v,1,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,1).target;
    const currVal_1:any = import1.ɵnov(v,1).href;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_MobileHeaderComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.refreshBooking()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(2),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[
      [
        'class',
        'rectangle new-icon'
      ]
      ,
      [
        'name',
        'mobile-new-booking'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['+ NEW']))
  ]
  ,(ck,v) => {
    const currVal_2:any = ck(v,2,0,'/booking-management','create-booking');
    ck(v,1,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,1).target;
    const currVal_1:any = import1.ɵnov(v,1).href;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export function View_MobileHeaderComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),41,'header',[[
        'id',
        'header-mobile'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MobileHeaderComponent_1)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',[
      [
        'class',
        'align-left'
      ]
      ,
      [
        'style',
        'padding-left: 50px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),32,'section',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MobileHeaderComponent_2)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MobileHeaderComponent_3)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),23,'ul',[
      [
        'class',
        'dropdown menu click-handler'
      ]
      ,
      [
        'data-click-open',
        'true'
      ]
      ,
      [
        'data-disable-hover',
        'true'
      ]
      ,
      [
        'data-dropdown-menu',
        ''
      ]
      ,
      [
        'onclick',
        'this.classList.toggle(\'opened\');'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),20,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'a',[
      [
        'class',
        'header__profile'
      ]
      ,
      [
        'id',
        'lnkProfile_mobile'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[[
        'class',
        'ImgSize'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'ul',[[
        'class',
        'menu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'a',[[
        'id',
        'lnkIndProfile_mobile'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,28).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(2),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-user'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        Profile'])),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'a',[[
        'id',
        'lnkLogout_mobile'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import4.MobileHeaderComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.userLogout()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-logout'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        Log Out'])),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.MobileHeaderComponent = v.component;
    const currVal_0:any = co.showBackLink;
    ck(v,3,0,currVal_0);
    const currVal_2:any = co.isCurrentUserNotIndividualClientOrOrg();
    ck(v,11,0,currVal_2);
    const currVal_3:any = co.isUserIndividualClientOrOrgRep();
    ck(v,14,0,currVal_3);
    const currVal_7:any = ck(v,29,0,'/user-management','profile');
    ck(v,28,0,currVal_7);
  },(ck,v) => {
    var co:import4.MobileHeaderComponent = v.component;
    const currVal_1:any = co.title;
    ck(v,6,0,currVal_1);
    const currVal_4:any = import1.ɵinlineInterpolate(1,'',co.getPicturePath(),'');
    ck(v,22,0,currVal_4);
    const currVal_5:any = import1.ɵnov(v,28).target;
    const currVal_6:any = import1.ɵnov(v,28).href;
    ck(v,27,0,currVal_5,currVal_6);
  });
}
function View_MobileHeaderComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-mobile-header',([] as any[]),(null as any),(null as any),(null as any),View_MobileHeaderComponent_0,RenderType_MobileHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import4.MobileHeaderComponent,[
      import2.Router,
      import5.BookingHeaderService
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const MobileHeaderComponentNgFactory:import1.ComponentFactory<import4.MobileHeaderComponent> = import1.ɵccf('app-mobile-header',import4.MobileHeaderComponent,View_MobileHeaderComponent_Host_0,{
  title: 'title',
  backLink: 'backLink',
  showBackLink: 'showBackLink'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/ui/mobile-header/mobile-header.component.ngfactory.ts